import cuid from "cuid";
import { store } from 'Store/store.index';
import { storageGetItem, storageRemoveItem, getQueryVariable, convertMIMETypeToFileExtension, windowActionFn } from 'Utils/utils'
import { GOOGLE_DRIVE_ACCESS_TOKEN } from '@/constants/local.constant'
import { convertController } from "@/components/viewer/Controllers/index";
import { USER_SIGN_IN_SUCCESS } from "Store/constants";
import { thirdPartyService } from "@/store/services";

export const GoogleDriveFlow = (emitter: any, fileTabRef: any, folderPath: any, onHandlePDFByResponse: Function) => {
  const driveName = 'Google Drive'
  const googleDriveAccessToken =  storageGetItem(localStorage, GOOGLE_DRIVE_ACCESS_TOKEN)
  const fileParams = getQueryVariable('state');
  const doOpenFile = () => {
    let fileItem: Object
    const fileParamsString = JSON.parse(decodeURI(fileParams));

    if (fileParamsString.ids) {
      fileItem = { id: fileParamsString.ids[0]};
    } else if (fileParamsString.exportIds) {
      fileItem = { id: fileParamsString.exportIds[0], mimeType: 'application/vnd.google-apps.spreadsheet' };
    }

    store.appStore.updateGoogleDriveInfo({isFromGoogleDrive: true})

    if (fileParamsString.action === 'open') {
      store.appStore.showLoading(true)
      store.driveStore.doOpenFile(
        driveName,
        fileItem,
        async ({ blob, id, fileName, parents }) => {
          blob.lastModifiedDate = new Date();
          blob.name = `${fileName}.${convertMIMETypeToFileExtension(blob.type.split('/')[1])}`;
          store.appStore.showLoading(false)
          store.docStore.setDocDriveName(driveName);

          // pdf文件无需登录
          if (blob.type === 'application/pdf') {
            fileName = `${fileName}.pdf`

            store.driveStore.updateGoogleDriveFilesInfoArr([Object.assign(fileItem, {name: fileName})])
            fileTabRef.current.wrappedInstance.onOpenFile({ driveName, blob, id, fileName, folderPath, item: fileItem });
          } else {
            // 非pdf文件需要登录
            const {hasSignIn} = store.userStore
            const doConvertToPDF = () => {
              convertController.doConvertToPDF(
                blob,
                (result) => {
                  store.appStore.updateGoogleDriveInfo({isConverted: true})
                  store.driveStore.updateGoogleDriveFilesInfoArr([Object.assign(fileItem, {name: `${fileName}-${cuid()}.pdf`, folderPath: [{id: parents}]})])
                  onHandlePDFByResponse(result);
                },
                (/*err*/) => {},
                true,
              );
            }

            const checkPermissionParams: any = {addInType: 'GoogleDrive', hasPermissionCallback: doConvertToPDF}

            if (hasSignIn) {
              const checkPassed = await thirdPartyService.checkPermissionAndReflect(checkPermissionParams)

              !checkPassed && store.appStore.showLoading(false)
            } else {
              store.userStore.loginIn(null, {isFromUserHandleLogin: true});
              emitter.on(USER_SIGN_IN_SUCCESS, async () => {
                const checkPassed = await thirdPartyService.checkPermissionAndReflect(checkPermissionParams)
                
                !checkPassed && store.appStore.showLoading(false)
              });
            }
          }
        },
        () => {
          store.appStore.showLoading(false)
          storageRemoveItem(localStorage, GOOGLE_DRIVE_ACCESS_TOKEN)
          store.driveStore.redirectToGoogleOAuth(fileParams)
        },
      );
    }
  }

  function doAuthorization() {
    store.driveStore.doAuthorizationForGSuite(doOpenFile)
  }

  //ONLINERD-2199 Update G Suite's settings to recommend user to complete additional setup
  if(!fileParams || fileParams === 'gdriveSetupInstruction')return;

  if (googleDriveAccessToken) {
    doOpenFile()
  } else {
    doAuthorization()
  }
}